'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "mode", "onModeChange", "onEmbedRemove", "onEmbedSave", "eventKey"];
import PropTypes from 'prop-types';
import { useState, useEffect, useCallback, useRef } from 'react';
import { PopoverBodyMode } from 'rich-text-lib/constants/popover';
import EmbedPopoverBodyBranch from 'rich-text-lib/components/embed/EmbedPopoverBodyBranch';
import TinyMcePopover from './TinyMcePopover';
import withPopoverModeState from './withPopoverModeState';
import { getSource } from '../hsmedia/util';
import { jsx as _jsx } from "react/jsx-runtime";
function EmbedPopoverManager(props) {
  const {
      editor,
      mode,
      onModeChange,
      onEmbedRemove,
      onEmbedSave,
      eventKey
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [target, setTarget] = useState(null);
  const [embedOptions, setEmbedOptions] = useState({});
  const lastTarget = useRef(target);
  useEffect(() => {
    lastTarget.current = target;
  });
  const handleRemove = useCallback(() => {
    if (lastTarget.current) {
      setTarget(null);
      setEmbedOptions({});
    }
  }, []);
  useEffect(() => {
    const handleHsNodeChange = ({
      element
    }) => {
      if (!element) {
        handleRemove();
        return;
      }
      setEmbedOptions({
        embed: getSource(editor, element)
      });
      if (element !== lastTarget.current) {
        onModeChange(PopoverBodyMode.PREVIEW);
        setTarget(element);
      }
    };
    editor.on(`hsNodeChange:${eventKey}`, handleHsNodeChange);
    return () => editor.off(`hsNodeChange:${eventKey}`, handleHsNodeChange);
  }, [editor, handleRemove, onModeChange, eventKey]);
  return /*#__PURE__*/_jsx(TinyMcePopover, {
    "data-test-id": "embed-popover-manager",
    editor: editor,
    open: !!target,
    target: target,
    onRemove: handleRemove,
    placement: mode === PopoverBodyMode.PREVIEW ? 'bottom' : 'right',
    content: /*#__PURE__*/_jsx(EmbedPopoverBodyBranch, Object.assign({
      mode: mode,
      onModeChange: onModeChange,
      onRemove: handleRemove,
      onEmbedRemove: onEmbedRemove.bind(null, target),
      onEmbedSave: onEmbedSave.bind(null, target),
      dropdownClassName: "mce-ui-select",
      tooltipClassName: "mce-embed-tooltip"
    }, embedOptions, rest))
  });
}
EmbedPopoverManager.propTypes = {
  editor: PropTypes.object.isRequired,
  mode: PropTypes.oneOf(Object.keys(PopoverBodyMode).map(key => PopoverBodyMode[key])),
  onModeChange: PropTypes.func,
  onEmbedRemove: PropTypes.func.isRequired,
  onEmbedSave: PropTypes.func.isRequired,
  showAlignmentControls: PropTypes.bool,
  showMarginControls: PropTypes.bool,
  staticPrefix: PropTypes.string,
  eventKey: PropTypes.string
};
export default withPopoverModeState(EmbedPopoverManager);